import type { IFilter } from '@models/Filter'
import type { Query } from '@models/Query'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../../gateways/api'
import type {
  FetchWerklijsten,
  FetchWerklijstenFilters,
} from '../types/FetchWerklijsten'

export { fetchWerklijsten, createFilters, initialState }

const fetchWerklijsten = async ({
  query,
}: {
  query: Query<FetchWerklijstenFilters>
}): Promise<FetchWerklijsten['data']> => {
  const { filters } = query

  const { data } = await apiClient({
    url: '/rest/dashboard/aansluiting/werklijst',
    method: 'POST',
    data: { filters: createFilters(filters) },
  })

  return data
}

const createFilters = ({
  organisatie,
  gebied,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
  labels,
  myList,
}: FetchWerklijstenFilters) => {
  const filters: IFilter[] = []

  if (organisatie)
    filters.push({
      name: 'organisatie',
      value: organisatie.label,
      operator: 'eq',
    })

  if (gebied && gebied.length > 0) {
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  }

  if (fromGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: startOfDay(fromGeplandeUitvoeringsdatum),
      operator: 'gte',
    })
  }

  if (toGeplandeUitvoeringsdatum) {
    filters.push({
      name: 'geplandeUitvoeringsdatum',
      value: endOfDay(toGeplandeUitvoeringsdatum),
      operator: 'lte',
    })
  }

  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  filters.push({
    name: 'isActive',
    value: true,
    operator: 'eq',
  })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  return filters
}

const initialState: FetchWerklijsten = {
  data: {
    acties: [],
    activiteiten: [],
    bijlagen: [],
    reviewBijlagen: [],
    subprocessen: [],
  },
  query: {
    filters: {
      organisatie: null,
      gebied: [],
      fromGeplandeUitvoeringsdatum: null,
      toGeplandeUitvoeringsdatum: null,
      labels: [],
      myList: false,
    },
  },
}
